import React, { useRef, useState } from "react";

const ElevationInput = ({ index, value, setFormFields, formFields }) => {
  const [feetX, setFeetX] = useState("");
  const [feetY, setFeetY] = useState("");
  const [metersX, setMetersX] = useState("");
  const [metersY, setMetersY] = useState("");

  const feetYRef = useRef(null);
  const metersXRef = useRef(null);
  const metersYRef = useRef(null);

  const handleFeetXChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,4}$/.test(value)) {
      setFeetX(value);
      if (value.length === 4) {
        feetYRef.current.focus();
      }
    }
  };
  const handleFeetYChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,1}$/.test(value)) {
      setFeetY(value);
      if (value.length === 1) {
        metersXRef.current.focus();
      }
    }
  };

  const handleMetersXChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,4}$/.test(value)) {
      setMetersX(value);
      if (value.length === 4) {
        metersYRef.current.focus();
      }
    }
  };

  const handleMetersYChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,1}$/.test(value)) {
      setMetersY(value);
      updateFinalValue(feetX, feetY, metersX, value);
    } else {
      updateFinalValue(feetX, feetY, metersX, metersY);
    }
  };

  const updateFinalValue = (feetX, feetY, metersX, metersY) => {
    const finalValue = `${feetX}.${feetY}ft./${metersX}.${metersY}m.`;
    const fields = [...formFields];
    fields[index]["elevation"] = finalValue;
    setFormFields(fields);
    console.log(finalValue, "console");
  };

  return (
    <>
      <label>Elevation</label>
      <div className="flex border border-input rounded-md gap-4 items-center px-2">
        <input
          type="text"
          value={feetX}
          onChange={handleFeetXChange}
          className="h-10 border-none shadow-none z-0 w-10"
        />
        <span style={{ fontWeight: "bolder" }}>.</span>
        <input
          type="text"
          ref={feetYRef}
          value={feetY}
          onChange={handleFeetYChange}
          className="h-10 border-none shadow-none z-0 w-10"
        />
        <span>ft./</span>
        <input
          type="text"
          ref={metersXRef}
          value={metersX}
          onChange={handleMetersXChange}
          className="h-10 border-none shadow-none z-0 w-10"
        />
        <span>.</span>
        <input
          type="text"
          ref={metersYRef}
          value={metersY}
          className="h-10 border-none shadow-none z-0 w-10"
          onChange={handleMetersYChange}
        />
        <span>m</span>
      </div>
    </>
  );
};

export default ElevationInput;
